export enum CopType {
	CUBE_CAMERA = 'cubeCamera',
}
